import React from "react";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { ProfileModalContentWrapper } from "../shared/Modal/Modal.styles";
import { SuccessMessageWrapper } from "./SuccessMessage.styles";
import { FinalSuccessMessage } from "./FinalSuccessMessage";

interface FinalSuccessConfirmationProps {
  onPrimaryAction: () => void;
}

export const FinalSuccessConfirmation: React.FC<
  FinalSuccessConfirmationProps
> = ({ onPrimaryAction }) => {
  const { deviceType } = useDeviceHook();

  return (
    <SuccessMessageWrapper deviceType={deviceType}>
      <ProfileModalContentWrapper>
        <FinalSuccessMessage onPrimaryAction={onPrimaryAction} />
      </ProfileModalContentWrapper>
    </SuccessMessageWrapper>
  );
};
